/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_Custom_Property4Inputs */

const en_tables_skill_groups_custom_property4 = /** @type {(inputs: Tables_Skill_Groups_Custom_Property4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property4`)
};

const de_tables_skill_groups_custom_property4 = /** @type {(inputs: Tables_Skill_Groups_Custom_Property4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property4`)
};

/**
* | output |
* | --- |
* | "Property4" |
*
* @param {Tables_Skill_Groups_Custom_Property4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_custom_property4 = /** @type {((inputs?: Tables_Skill_Groups_Custom_Property4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_Custom_Property4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_custom_property4(inputs)
	return de_tables_skill_groups_custom_property4(inputs)
});